export async function verifyUser(email, password) {
  const res = await fetch("https://cqcexperts.com/verify-user2.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) throw new Error("Network error");

  const data = await res.json();
  return data; // return full response including placeholders
}
